import { render, staticRenderFns } from "./bonusv0.vue?vue&type=template&id=aaa0479e&scoped=true"
import script from "./bonusv0.vue?vue&type=script&lang=js"
export * from "./bonusv0.vue?vue&type=script&lang=js"
import style0 from "./bonusv0.vue?vue&type=style&index=0&id=aaa0479e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa0479e",
  null
  
)

export default component.exports